import { render, staticRenderFns } from "./PedidoOnlineDrawer.vue?vue&type=template&id=1fb34000&scoped=true"
import script from "./PedidoOnlineDrawer.vue?vue&type=script&lang=js"
export * from "./PedidoOnlineDrawer.vue?vue&type=script&lang=js"
import style0 from "./PedidoOnlineDrawer.vue?vue&type=style&index=0&id=1fb34000&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb34000",
  null
  
)

export default component.exports